///<reference path='../../core/utils/Dictionary.ts'/>

'use strict';
namespace TR {

    import Dictionary = Core.Collections.Dictionary;
    import DriverType = Core.Booking.DriverType;

    interface UserData {
        Rooms: Room[];
    }

    interface Room {
        Guests: Guest[];
    }

    interface Guest {
        DriverType: DriverType;
        FirstName: string;
        Id: number;
        Label: string;
        LastName: string;
        Title: string;
        Type: number;
    }

    interface CarHireDriver {
        name: string;
        id: number;
    }

    interface DriverTypeModel {
        title: string;
        type: DriverType;
        driverId: number;
        ineligible: boolean;
    }

    interface RequestedItemsCosting {
        CurrencyCode: string;
        Total: number;
    }

    class CarHireSelection {

        private bookingLoaded: boolean;
        private userData: UserData;

        public additionalDrivers: number;
        public captureDrivers: boolean;
        public carhire: any;
        public drivers = new Dictionary<CarHireDriver>();
        public driverTypeModels: DriverTypeModel[];
        public requestedItemsCosts: RequestedItemsCosting;

        constructor(
            private $scope: ng.IScope,
            private resourceService: Core.ResourceService
        )
        {
            const wait = $scope.$watch('chs.bookingLoaded', b => {
                if(b) {
                    this.init();
                    wait();
                }
            });

            $scope.$watch('chs.userData.Rooms', (u: Room[]) => {
                if(u) {
                    this.updateDriverTitles(this.drivers, u);
                }
            }, true);
        }

        public updateDriverType(value: DriverType, newDriverId: number, oldDriverId: number) {
            //find the new and old driver ids and update our user data accordingly
            this.findAndUpdateDriverType(this.userData.Rooms, oldDriverId, DriverType.NotADriver);
            this.findAndUpdateDriverType(this.userData.Rooms, newDriverId,  value);
        }

        private init() {
            if (this.captureDrivers) {
                this.updateDriverTitles(this.drivers, this.userData.Rooms);

                if (this.drivers.count() === 0) {
                    this.captureDrivers = false;
                    return;
                }

                const guests = this.getGuestList(this.userData.Rooms);

                this.driverTypeModels = [
                    {
                        title: this.resourceService.get('MAINDRIVER'),
                        type: DriverType.MainDriver,
                        driverId: this.getGuestIdForDriverType(guests, DriverType.MainDriver),
                        ineligible: false
                    }
                ];
                if (this.additionalDrivers > 0 && guests.length >= 1) {
                    const adults = guests.filter(g => { return g.Type === 1; });
                    this.driverTypeModels.push({
                        title: this.resourceService.get('ADDITIONALDRIVER'),
                        type: DriverType.AdditionalDriver,
                        driverId: this.getGuestIdForDriverType(guests, DriverType.AdditionalDriver),
                        ineligible: adults.length === 1
                    });
                }
            }
        }

        private findAndUpdateDriverType(rooms: Room[], guestId: number, driverType: DriverType): void {
            _.each(rooms, r => {
                let keepGoing: boolean = true;
                _.each(r.Guests, g => {
                    if (g.Id === guestId-1) {
                        g.DriverType = driverType;
                        keepGoing = false;
                        return keepGoing;
                    }
                });
                return keepGoing;
            });

            //check the same driver is not assigned to another driver type
            //clear it if he is
            if (driverType !== DriverType.NotADriver) {
                let models = _.filter(this.driverTypeModels, { 'driverId': guestId});
                if (models.length > 1) {
                    _.find(models, d => { return d.type !== driverType; }).driverId = 0;
                }
            }
        }

        private getGuestIdForDriverType(guests: Guest[], type: DriverType): number {
            //get the guest id for the given type
            //NOTE ids start at 0 but this is not what we want as 0 is counted as a blank/unset value so bump the
            //guest Id to be something we can work with
            const g = _.find(guests, {'Type': 1, 'Age': 21, 'DriverType': type});
            if (g) {
                return g.Id + 1;
            }
            return 0;
        }

        private updateDriverTitles(dict: Dictionary<CarHireDriver>, rooms: Room[]): void {
            //update the driver titles we have stored
            _.each(rooms, room => {
                _.each(_.filter(room.Guests, {'Type': 1, 'Age': 21}), guest => {
                    const name = (guest.Title && guest.FirstName && guest.LastName) ?
                        `${guest.Title} ${guest.FirstName} ${guest.LastName}` :
                        guest.Label;

                    const id = guest.Id + 1;
                    if (dict.containsKey(id.toString())) {
                        let driver = dict.item(id.toString());
                        if (driver.name !== name) {
                            driver.name = name;
                        }
                    } else {
                        dict.add( id.toString(), { name: name, id: id });
                    }
                });
            });
        }

        private getGuestList(rooms: Room[]) :Guest[] {
            return _.reduce(rooms, (result, room) => {
                return result.concat(room.Guests);
            }, <Guest[]>[]);
        }
    }


    angular
        .module('TR')
        .directive('carhireSelection', () => {
            return {
                bindToController: true,
                controller: CarHireSelection,
                controllerAs: 'chs',
                restrict: 'E',
                replace: true,
                scope: {
                    additionalDrivers: '=',
                    bookingLoaded: '=',
                    captureDrivers: '=',
                    carhire: '=',
                    requestedItemsCosts: '=',
                    rootForm: '=',
                    userData: '=',
                    templateVersion: '@'
                },
                templateUrl: (element, attr) => {
                    if(attr.templateVersion) {
                        return 'partials/booking/template?name=CarHireSelection&version='
                        + attr.templateVersion;
                    } else {
                        return 'partials/home/directivetemplate?type=CarHireSelection';
                    }
                }
            };
        });
}
